import {
  SubscriptionException,
} from '@/domain/stripe/customer/sub-domains/subscription/model/exception/SubscriptionException'

export class UnknownSubscriptionException extends SubscriptionException {

}
